module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "إنسانية-بطعم-الحب"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنسانيَّةٌ بطعمِ الحُبِّ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("توقَّفَ راضي عند كشك أبي سمرة وطلبَ علبةَ سجائر وكأسَ شاي، نظرَ إليه الرَّجلُ العجوز ليُعاينَ الحالةَ الَّتي يمرُّ بها، واكتشفَ بسرعةٍ أنَّها حالةُ غضبٍ سامَّةٍ، أعدَّ له ما طلبَ؛ وأخرج لنفسه كوباً مماثلاً وجلسَ إلى جانبه، وقالَ لهُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا الغضبُ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لستُ غاضباً!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الغضب سمٌّ يؤذي الجميعَ، أنتَ الآن تُؤذي نفسكَ، وتؤذي من تحبّ، ومن يهتمُّ لأمرك.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو أنَّ لا أحد يهتمُّ لأمري.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إذن، سأتركُكَ بمفردكَ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نادى راضي مُستدركاً:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبا سمرة، أنا لا أقصدُكَ أنتَ، حديثي حديثٌ عام.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التفَت أبو سمرة وعاد مؤنباً:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندما نتحدَّثُ عن المحبّةِ والاهتمام، يجبُ أن تكونَ كلماتُنا دقيقةً وشافية، أو على الأقلِّ غير مؤذيةٍ، يجبُ أن تتعلَّمَ شيئاً مهمّاً: لا حبَّ بالإكراه، لن يحبَّكَ أحدٌ فُرضَ عليهِ ذلك، المحبَّةُ ارتقاءٌ وشعورٌ يولدُ عنوةً، يُكسبُنا قوَّةَ المواجهة والتحدِّي لنحميَ من نحبّ.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو أنَّكَ تحبُّني أيُّها العجوز!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ شابٌّ من خامةٍ جيدة، لا أعرف عنكَ شيئاً، إلَّا أنّي أراقبُكَ منذ زمنٍ، أنتَ وتلك الشابَّة الَّتي تصطحبُها إلى تلك الحديقة، أنظرُ إلى مقعدِكما دائماً، عندما تجلسان عليه تتجمَّع فوق تلك الشجرة الَّتي تُظلِّل المقعدَ طيورٌ كثيرة، وهذه إشارة على الصّدقِ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استغربَ راضي صراحةَ العجوز ونبوءَته، وقال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تراقبُ الجميعَ؟")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا، لستُ من هواةِ التَّمثيلِ والتصنُّعِ، أنا أعتني بالمحبّين فقط.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("آه يا أبا سمرة، متى ستروقُ لي الحياة؟ متى ستصبحُ سلسةً ممهدّةً أمامي؟ متى سينتهي شقائي؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عادَ الرَّجلُ لداخل الكشكِ وهو يتمتمُ بهدوء:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تصرَّف على أنَّهُ لن ينتهي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تابعَهُ راضي بنظراتهِ، وعلا صوتُه من جديد:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا تقصد؟ أستبقى أيَّامي كلُّها بهذا التَّعقيد؟!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا لا أراها مُعقَّدةً، أنا أرى أنَّكَ تعيش أيَّاماً جيّدةً، وتحبُّ فتاةً تحبُّكَ، وكفاك من الحياة أيّ متعة أُخرى!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو أنَّكَ لا تعرف شيئاً.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ربَّما، ولا أُريدُ أن أعرفَ، اكتفيتُ من المعرفةِ منذُ زمنٍ، أنا مُتصالحٌ مع نفسي ومع حياتي، ولا أُريدُ شيئاً آخر.")])])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظهرت على وجه راضي نظرةَ تعجُّبٍ وتهكُّمٍ بنفس الوقت وهو يقولُ:اكتفيتَ من الدُّنيا!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أقُلْ إنِّي اكتفيْتُ من الدنيا قلت أنني اكتفيت من المعرفة، هناك أشياء كثيرةٌ أنتظرُ حدوثَها، وستحدثُ حتماً، إلَّا أنَّني تعلَّمتُ فنون الانتظار.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أطرقَ راضي وتصنَّعَ هدوءاً يشبهُ هدوءَ أبي سمرة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ربَّما سيأتي يومٌ أحسدُكَ فيه على رضاكَ وقناعتِكَ، لكنَّه ليس اليوم، شكرا على الشَّاي، أراك لاحقاً.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خرجَ راضي بعدَ أن هدأ قليلاً، ونسيَ الغضب الَّذي جعلَه يتركُ حبيبتَهُ تذهبُ وحيدةً، حاول اللَّحاقَ بها، أدركَها قبل أن تصلَ بيتها، لوَّحَ لها من بعيد وابتسمَ، أرسلَ لها قُبلةً في الهواء وغادر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يأتي أبو سمرة إلى كشكِه كلَّ يومٍ في الثَّامنة صباحاً، ويغادرُه في التَّاسعة مساءً في كلِّ يومٍ، وفي كلِّ الفصول، ولا يوجدُ أيُّ حجَّةِ غيابٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يعملُ أبو سمرة في الحي منذُ خمسةٍ وأربعين عاماً، يعرفُه الجميعُ، ويتناقلون أقوالَه الحكيمةَ ونصائحَهُ البليغة، يخرجُ يوميًّا للمشي، ليس هناك ساعةٌ محدَّدة، ولا يقفل كشكه أبداً، يبدو أنَّه ليس له أقاربُ ولا حتَّى أبناء، ولا يعرفُ أحدٌ من أين أتى، عمرُه قاربَ الثَّمانين، لا يشكو إلَّا من ضعفٍ في البصر، عالجَهُ بنظَّارتهِ البنيَّة الكبيرة الَّتي تُبرزُ تجاعيد وجههِ العميقة حين يرتديها، كما أنَّ خطواته أصبحَت متثاقلةً بحكمِ العمر والشيخوخة، يستقبلُ أبو سمرة كلَّ مَن يقصدُه بابتسامٍ وترحيبٍ، ويحاولُ تلبيةَ الطَّلباتِ على اختلاف تنوِّعها، وفي أحيان كثيرةٍ يتركُ معه العاشِقين ملاحظاتٍ يعرفون أنَّهُ سيحتفظُ بها، وسيسعى لأن يوصلَها لأصحابها في الوقت والمكان المناسبَين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بضاعةُ أبي سمرة بسيطةٌ مزيَّنةٌ بالورود والفواكه دوماً، تساءَل راضي كثيراً: \"كيفَ يعيشُ هذا العجوز؟ كيف يكفيه هذا الكشكُ المتواضعُ كفاف حياتِه في هذه الأيَّام الصَّعبة؟\"، وقرَّر يوماً أن يسألَهُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبا سمرة، أين تعيش؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ العجوزُ باستغراب وقالَ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في بيتي!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أينَ بيتُكَ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الضَّواحي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ملك أم إيجار؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ملك، الملك لله.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَن يعيشُ معكَ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآن، لا أحد، توفيَت والدتي منذُ ثلاثين سنةً.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ووالدك!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("توفّي قبلها، ولكنَّه لم يكُنْ معنا.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعتذرُ عن التدخُّل؛ ولكنَّ القصَّةَ تبدو مشوِّقةً!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ تدرسُ الإعلام، أليس كذلك؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، وهذا عامي الأخير.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمَ الرَّجل بمحبّة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إذاً، هذا هو عملُكَ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمَ راضي، وتابع:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقصدُ البحثَ عن القصص! نعم، أنا أحبُّ القصص المخبَّأةَ بالزَّمن.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تابعَ أبو سمرة الحديثَ ويداه مشغولتان بفرزِ حبّات الفاكهة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وما هيَ قصَّتكَ أنت؟")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا، قصَّتي طويلةٌ، ويبدو أنَّها تزدادُ تعقيداً!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لكلِّ عقدةٍ حلٌّ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأتُ أؤمنُ أنَّ هناكَ عقداً لا يمكنُ حلُّها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هناك حلٌّ سحريٌّ لكلِّ العُقدِ العنيدة!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما هو؟ أرجوكَ أخبرني!")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ أبو سمرة مباشرةً إلى وجهِ راضي، وقالَ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المحبّة.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المحبّة، دونَ أيِّ شرحٍ أو توضيح!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما التَّوضيح الَّذي تريده؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبا سمرة، هل تعلَّمْتَ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كنتُ كسولاً جدّاً؛ كرهْتُ المدرسةَ، وكرهني جميعُ من حولي، تركتُ المدرسةَ وبدأتُ طريقي بعيداً عنها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وتتحدَّثُ عن المحبّة! إذاً كنتَ قد بدأْتَ حياتَكَ بكراهية أجبرَتكَ على تركِ التَّعليم!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا لم أنفِ وجودَ الكراهية، أنا تحدَّثتُ عن أثر المحبّةِ في الحياة، مَن هو أكثرُ شخصٍ تحبَّه أو أحببتَهُ يوماً؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فكَّرَ راضي بسرعةٍ وأجابَ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هناكَ إجابتان، الشَّخصُ الَّذي أحبُّه هي صديقتي الَّتي تعرفها، أمَّا أكثر شخصٍ أحببته يوماً فهي أمّي، هل تعرفُ أنَّها أنجبَتْ اثني عشرَ طفلاً، تسعة من الذّكور وثلاث من الإناث، لم أفهَم سياسةَ أبي الإنجابيَّة يوماً، كانَ فقيراً جدّاً، تربَّينا في بيتٍ مؤلَّفٍ من غرفةٍ واحدةٍ ومطبخ، لم يعرفْ أحدٌ منّا معنىً حقيقيّاً للطُّفولة، كلّ أخوتي، وأنا أصغرهم، بدأنا العملَ في سنِّ العاشرة، لم يكُنْ ذلك كافياً بالنِّسبة لوالدتي الَّتي أصرَّتْ على التَّعليم، اعتادَت أن تضعَنا في الغرفةِ الوحيدة، بعد العودة من أعمالنا لإنجاز فروضنا")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وواجباتنا المدرسيَّة، شهدْتُ حالاتِ تمزيق واجباتٍ كثيرة، لا يعجبُها الخطُّ أو التَّرتيبُ أو مدى دقّة الحلِّ، تمزِّقُ الورقَ وتطلبُ إعادة الحلِّ، لم أكتشفْ أنَّها أُميَّةٌ لا تعرفُ القراءةَ إلَّا في المرحلة الثَّانوية، وعندَما واجهتُها ابتسمَت وقالت لي: أخيراً اكتشفْتَ أيُّها الصَّغير! وها نحنُ الآن، خمسة من إخوتي أطبَّاء، وثلاثة من المهندسين، أختاي الكبيرتان تعملان في مجال التَّربية الخاصَّة، وأختي الَّتي تكبرُني محاميَّة مرموقة، ثمَّ أنا عام واحد يفصلُني عن التخرُّج، ولكنَّني غارقٌ في أمواج هذه الحياة.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما الَّذي يشغلُ بالك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ضحكَ راضي كثيراً، وقالَ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تُؤاخذني يا عمّ، أنتَ الآن على أعتابِ هذه الحياة، ربَّما تنظرُ إليَّ على أنَّني مُتسرِّعٌ أو ساذجٌ، ولكنَّ الأمور في عصرنا باتَت أكثر تعقيداً!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلسَ أبو سمرة، وضعَ يديه على ركبتيه وبدأَ بسردِ بعض حِكَمِهِ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اسمعْ أيُّها الشابُّ، إنَّ الحياةَ ستمضي بك، وستصلُ يوماً لمُبتغاكَ، الفرقُ يكمنُ بشعورِكَ أثناء المسير، عليكَ أن تكونَ سعيداً، وأن تستمتعَ بكلِّ التَّفاصيل، لا تغفلْ أمراً، ولا تنسَ أحداً، عليكَ أن تُدخِلَ الفرحَ والطَّمأنينة لقلوبِ مَن حَولكَ، عندَها ستشعرُ بالأمان، وتنطلقُ بقوَّة؛ لأنَّكَ واثقٌ من سلامةِ ما بنيت.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أستغربُ الثِّقة المطلقةَ في كلامِكَ!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تستغرب، الحياةُ تُراهِن على أشياء مختلفةٍ، وتحافظ على ثباتِ مسيرها، تتحدَّى سرعةَ ومدى فهمِنا لمعطياتها، ويقعُ على عاتقنا مدُّ سُبلِ التَّواصُل بينَنا وبينها، بعدَ ذلك ستُجيد قراءةَ رسائلها، وفهم تلميحاتها، والاستعداد لمفاجآتها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهل استطعتَ أنتَ فهمَ ذلك؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طبعاً، قلتُ لكَ أنا أشعرُ بالسَّكينةِ والرِّضا.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أحسدُك يا أبا سمرة، وأرغبُ الوصولَ لحالتِك؛ لكنَّ الكثيرَ يمنعُني من ذلك.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قُلْ لي هلْ تُحبُّ تلك الفتاةَ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، أحبّها كثيراً!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اشرحْ لي، كيفَ تحبُّها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشعرُ بوجودِها أنَّ الهواءَ يزدادُ نقاءً، والوقت يفقدُ معناه، أخرجُ بعيداً عن نطاقِه، وكأنَّني محجوزٌ في لحظاتٍ لا تُقاس بقياساته، في حضورٍها أشعرُ أنَّني مُختلِف، أشعرُ أنَّني جميلٌ جداً من الدَّاخل والخارج، وجودُها يُضفي ألواناً برَّاقةً على الكلمات، فتتحوَّلُ من حبرٍ أسودَ لأزهار تُنيرُ الدّروبَ الموصدة.")])])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خلعَ أبو سمرة نظَّارتَه وحاول تنظيفَها ليُخفِي تأثُّره بكلمات راضي، ثمَّ قال:أنتَ صادقٌ في حبّكَ، حافظْ على تلك الصبيَّة سعيدةً، هي مصدر سعادتِكَ.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طريقُ الوصولِ إليها صعبٌ؛ هي من عائلةٍ غنيَّة جدّاً، وأنا طريقي يبدأُ من مكانٍ أدنى من الصِّفر بكثير، لا أعرف إذا كانَ بإمكاني التَّفكير بالزَّواج قبل عشر سنواتٍ على الأقل.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وكيف يمكن لتأخر الزواج أو عدم حدوثه أن يكون عائقاً أمام المحبة؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ الشابُّ نظرةَ استغرابٍ حقيقيَّة، وظهرَتِ الدَّهشةُ من عينيهِ بطريقةٍ علنيَّة:")])])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا؟ ما هي نهايةُ الحبِّ إذا لم يكُنِ الزَّواج؟")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهايةُ الحبِّ هي الحبُّ، الحبُّ أسمى من لقاءِ الجسد، هو حالةٌ نحياها لنكونَ قادرين على معرفةِ مغزى هذه الحياة وماهيَّتها، المحبّةُ هي سعي دائمٌ لإسعاد من نُحبُّ، سواء كنّا بصحبتهم أم لم نكن!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ تُبالغُ، كلامُكَ هذا لا ينطبق على هذا العالَمِ وهذه الحياة، ربَّما في الجنَّةِ، أو في المدينة الفاضلة!")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ العجوزُ للشابّ، تركَهُ متخبِّطاً في كلماتِه واعتذرَ منهُ لأنَّ عليه أن يمشي قليلاً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقعُ الكشكُ على زاوية الحديقة الَّتي يقصدُها العاشقون، أو مَن في عِدادهم، من كلِّ أنحاء المدينة، في حيٍّ راقٍ جدّاً، تحيط بالحديقة مجموعةٌ من الأبنية الفاخرة، تُعدُّ الأغلى بسبب إطلالتها على هذه الحديقة بالذَّاتِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تشهدُ الحديقةُ حركةً جيدة لممارسة الرِّياضة، يرتادها الجميعُ: صغاراً كباراً شباباً وشيّاباً، يمشي أبو سمرة يوميّاً في أوقاتٍ مختلفة، ودون أيّ إنذارٍ لمواعيد رياضته، عندما استأذن من راضي هذه المرَّة، بقي الأخيرُ جالساً يُراقبُه، وجدَه يمشي خلفَ سيِّدةٍ متقدِّمةٍ في العمر، تفصلُ بينهما خطوتان أو ثلاثٌ فقط، لم يكلّمْها، ولم تلتفتْ إليه، إلَّا أنَّه كان واضحاً أنَّها مدركةٌ للحاقه بها؛ تمشي بهدوء كي يتمكَّن مِن تتبُّع خطاها، عندما عاد أبو سمرة صعدَت السيّدةُ لإحدى البنايات الَّتي تُطلُّ على الحديقة والكشكِ مباشرةً، وعادَ هو إلى كشكه لاهثاً.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أما زلتَ هنا؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتظرُكَ! مَن تلك السيّدةُ الَّتي لحقْتَ بها؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ العجوزُ باستهجانٍ من تحتِ نظَّارته، ثمَّ التفت بعيداً:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّها أحلام.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ومَن أحلام هذه؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قصَّتي طويلةٌ جدّاً، وعليَّ الذَّهاب لمنزلي، غداً لنا لقاءٌ آخر.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عادَ أبو سمرة إلى منزله في رحلته اليوميَّة، مرَّ على قبرِ والدتِه ووضعَ بعضاً من ورود الياسمين البيضاء، قضىَ بضعَ دقائق وانصرف، واعداً إيَّاها بزيارةِ الغدِ وياسمين أكثر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصَّباح وقبلَ أن يصلَ العجوزُ كشكَه الصَّغير، وصل راضي حاملاً معهُ أوراقاً وأقلاماً، وكثيراً من الأسئلة، قضى ليله ساهراً يبحثُ عن افتراضات قصَّة مغلَّفةٍ بحكمةِ ذلك العجوز، قتله الفضولُ، وأنهكَهُ تخيُّلُ عوالِمَ حكاية مختلفة ستكون محوراً لمشروع تخرُّجه، جلسَ راضي بجانب الكشكِ ولاحظَ السيّدةَ الكهلة في الطَّابق الخامس تفتحُ بابَ شرفتها وتضعُ وعاءً تنمو فيه ورودَ النَّرجسِ، ووروداً أخرى، نظرَت إليه باستغرابٍ، وعرفَ من نظرتِها للبعيد، أنَّ أبا سمرة أصبحَ في المدى المرئيّ، وصلَ العجوزُ وانتبهَ للشُّرفة، وتمتمَ بصوت خفيت: \"جيّد، يومٌ جميلٌ آخر!\"، ردَّ راضي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل هي علامةٌ بينَكُما؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا، ولكن يمكنُ أن تكونَ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تحبّها؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم ينتظرِ العجوزُ كثيراً، وكأنَّه قرَّر البوحَ بقصَّته:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذُ متى؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذُ زمنٍ طويل جداً.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرَ أبو سمرة للشابِّ ووجدَه مرتَبِكاً بين أوراقه، هدَّأ من فوضاه، وقالَ له:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اسمع، ما سأقولُه، أنتَ لستَ بحاجةٍ لتدوينه، كلُّ التَّفاصيل ستُذكّرُك بنفسها، عليك أن تتعلَّم من هذه القصَّة؛ هذا ما يهمُّني حالياً.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تفضَّل، أنا متشوِّق لسماعك!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلسَ العجوزُ على كُرسيّ غُلِّفَ بطبقاتٍ قماشيَّة متعددةِ الألوان، شهدت أعواماً تفوقُ عمره، تنهَّد واستعدَّ وكأنَّهُ على وشكِ الاقتراب من كنزٍ محميٍّ بتعويذة سريَّة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولدتُ طفلاً دميماً ضئيلاً، لم يحبّني أحدٌ سوى والدتي، ربَّما لأنَّها أُصيبَت بالعمى ولم تُلاحظْ مدى قُبحِ شكلي بين بقيَّة الأطفال، زادَ الفقر من معاناتي: ثياب رثَّة، وشعر مجعَّد، وحذاء ممزَّق، أشياء جعلَت الجميع ينفرُ منّي، زادَ بطشُ أبي وعنفه مع أمّي الَّتي تحوَّلَ عالمَها لسواد حرمَها النَّظر، وزادَ من بصيرتها، فطلبَت منه الانفصالَ على أن تحتفظَ بي، وافقَ والدي بكلِّ رحابة صدرٍ، فالتَّعامُل مع زوجةٍ عمياء وطفل دميم المظهر لم يجعلْ حياتَه سعيدةً يوماً، عشتُ مع والدتي في بيتِ جدَّتها، توفيَتْ الأخيرةُ بعد أعوامٍ قليلة، تاركة لنا بيتَها المتواضِع ليأويني مع أمي، أصرَّت والدتي في البداية على ذهابي للمدرسة، كنتُ أشمُّ الكراهيَّة وأراها، يرميني بها الجميع، تألمَّت بصمتٍ دون أن أُخبِر أمّي الَّتي اعتادَت تفقُّدَ وجهي، وبدأَت تشعرُ برطوبة الدّموع عليه. في أحد الأيَّام، وكنتُ حينها في الصفِّ السَّادس، وهو الصفُّ الأخير الَّذي ارتدْتُه في المدرسة، أقبلَت عليَّ طفلةٌ في الصفِّ الأوَّل، جميلةٌ جدّاً تنثرُ الحبَّ والبراءة في الأرجاء، اقتربَت منّي وأعطتني نصفَ طعامِها دونَ أن تنطق بكلمةٍ واحدة، أكلْتُ ما قدَّمَتهُ لي، وشعرْتُ أنَّ فيه طعماً لم أعتدْهُ أبداً، طعم المحبّةِ، طعمَ أن أُعامَلَ كأيِّ شخصٍ سويّ آخر، مضتِ الأيَّامُ والطِّفلة تأتي لي كلَّ يومٍ بنصفِ طعامها ممزوجاً بمرحٍ وابتسامٍ وضحكٍ؛ جعلني أُبدِّد غيومَ الكراهيَّة السَّوداء الَّتي أحاطَت بي زمناً، بتُّ أخرجُ من زاويتي العفنة، الَّتي اعتدْتُ الجلوسَ فيها وأتبعُها، أراقبُها، أنتبهُ لخطواتها كي لا تقع، وذاتَ يومٍ لم تأتِ الفتاةُ إلى المدرسة، تكرَّرت الأيَّامُ وأصبح اليوم شهراً، بحثتُ عنها في كلِّ مكانٍ ولم أجدها، كنتُ لا أعرف عنها شيئاً، وكانت هي الوحيدةُ الَّتي أعطتني حبّاً، بكيت لأمّي ألماً، شعرَتْ بي وقالَت لي: \"ستجدُها قريباً، افتح قلبَكَ للمحبّة\"، تركتُ المدرسةَ، وقسوتُ على نفسي، وبدل أن أنفِّذَ ما طلبَتهُ أمّي، بتُّ أكرهُ نفسي أكثر، أجوب الشَّوارع، حزناً وجوعاً وألماً؛ في أحدِ الأيَّام عندَما عدتُ للمنزل، خجلتُ من قلق والدتي الَّتي طلبَت منّي بكلِّ حزم أن أرافقَ أحدَ الجيران في الصَّباحِ للعمل في كراجِ تصليح السيَّاراتِ في حارة القصور، ذهبتُ إرضاءً لأمّي الَّتي أوصتني صبراً وتأمُّلاً وحبّاً للجميع، في اليوم السَّابع للعمل سمعتُ صوتَ فتاتي الصَّغيرة، تشدو بضحكتها الَّتي تجعلُني أنسى أنَّني قبيحُ الوجه، اكتشفتُ أنَّها تسكن مع عائلتها في الجوار، وأنَّها ابنةُ أحد القُضاة المشهورين، حرستها في كلِّ خطواتها البريئة، وأرسلَتْ لي حبّها النقي بطعامِها الَّذي لم تعرفْ كيف تُنهيه يوماً، نما في قلبي شعورٌ مُختلِف أساسُه هي؛ فهي الَّتي جعلتني أرى نفسي جميلاً، وكل ما أردتهُ أن أرعاها وألَّا أكونَ سبباً في تعاستها، إن لم أستطعْ أن أكون سبباً في سعادتها، مرَّتِ الأيَّام وكبرنا، وأصبحَتِ الطِّفلةُ صبيَّةً جميلة تخطفُ الأنظار، عندما تمرُّ من أمامي تنظر إليَّ وتبتسم، وكأنَّها تملأ قلبي سعادةً، عندما تحزن تنظرُ من شرفتها لأبتكرَ طريقةً أُخرجُ فيها حزنها، رافقتُها في كلِّ أيَّامها: في امتحاناتها، في فرحِها، وفي يوم خطبتها وزواجها، لم أفكِّر يوماً بالزَّواج منها، اكتفيتُ برعايتها عن بُعدٍ، وهي أيضاً لم تطالبني بالكثير؛ فكلانا يعلمُ أنَّ الزَّواج لا يعني الحبَّ بالضَّرورة، وأنَّ الحبَّ مختلفٌ عن الزَّواج؛ زوجُها رجلٌ سلبَت منه الحياة نقاءَ النَّفس، وأسس الإنسانيَّة، وحوَّلته لشابٍ متهور مفتون بمُتعٍ الأنا والغرور والعَظَمة، لم يعرفْ كيف يُسعدها، أطفأَ مهجة روحها، وحوَّلها لسيدةٍ تقتات ببقايا الأمل، استمرَّت فترة خطبتها ثلاث سنوات، سألتُ نفسي كلَّ يومٍ فيها: \"ماذا سأفعلُ بعد زواجها؟\" وقبلَ موعد الزَّواج بشهر واحد جاءَت إلى مكان عملي أعطَتني أوراقاً كثيرة، وقالت لي: \"ستعملُ في هذا المكان\"، بحثتُ عن المكان في اليوم التَّالي، بدا مقفراً، جديداً، غيرَ مأهولٍ! شعرتُ بحزنٍ وكآبةٍ وقرَّرتُ الرَّحيل، إلَّا أنَّني لمحتُها قادمةً، وعرفتُ أنَّها نقلتني معها لأنَّها تُحبّني، اعتادَت منذُ اليوم الأوَّل وضعَ وعاء الأزهار على الشُّرفة لأعرفَ أنَّها بخير..")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وإذا لم تضعه!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ أبو سمرة العدَّ على أصابعِه:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المجموع حتَّى الآن سبعة أيَّام، ثلاثة منها عندَما أنجبَت أبناءها، ويوم وفاة والدتها، ويوم وفاة والدها.. (توقَّف قليلاً عندما وصلَ لليوم السَّادس، وتابعَ)، ويوم ضربها زوجها، كانت المرَّة الأُولى والأخيرة..")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا فَعَلتْ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتظرتُه لحين عودته، كانَ منظرُها يُبكي الحجر، آذاها كثيراً، ضربْتُه بقوَّةٍ ووعدْتُه بالقبر إذا أعادها!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهل تكرَّر ذلك؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يجرؤ، بقيَ حتَّى يوم وفاته يتلفَّتُ حولَه، كلَّما ترجَّل من سيَّارته!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("متى توفي؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذ عشرةِ أعوامٍ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("واليوم السابع!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اليوم السابع كان تعبيرا عن غضبها منّي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بماذا أغضبْتَها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندَما توفيت أمّي لم أفتحِ الكشكَ، قلقَت عليَّ كثيراً، في اليوم التَّالي لم تُخرجْ أزهاراً تعبيراً عن الغضب، لم تكن تعلم!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وكيفَ عرفَت؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندما رأتني.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دونَ أيِّ كلامٍ أو إشارة أو …")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ لم تفهم بعد، ما يجمعُني بها أقوى من اللُّغة، الشّعور بالآخر يتجاوزُ مرحلةَ التَّعبير، عندما يسكنُكَ شخصٌ ما يتغلَّبُ ما يشعر به على شعورِكَ، تبدأُ نفسك بالتنبُّؤ بما سيحدث له، وتقرأ في أنفاسه ونظراته ما حدثَ، أنا وهي لا نتبادلُ الحديثَ، إنَّنا متحابَّان؛ يعني أنَّ كلّاً منّا حريصٌ على سعادة الآخر، يُجهِد نفسه ليكون سبباً في راحة الآخر لا حزنه ولا تعبه، عندَما أدركَت أنَّني فقدْتُ أمّي، جلسَت على شرفتِها من الصَّباح حتَّى المساء؛ تعبيراً عن رغبتها بمساندتي، وفعلت، كنتُ سعيداً بها، شعرتُ أنَّها معي، حزنُها صادق، وتعاطُفها حقيقيٌّ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ألم تحزن على وفاة زوجها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ربَّما حزنت، ولكن ليس بالقدر الَّذي منعَها من وضعِ وعاء الأزهار في مكانه، عندَما تحبّ، تصبحُ حرّاً من كلِّ القيود، ويصبح التصنُّعُ من ترَّهاتِ الماضي، أنا أعرف أنَّها لا تحبّه، ولم تكنْ مجبرةً على الحزن عليه.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين أبناؤها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الكبيرُ مسؤول هامٌّ في الحكومة، مشغول دائماً، لا يزورها إلَّا قليلاً، الثَّاني هاجرَ بعد أن تعثَّر في مواضيع السياسة، الثَّالث يزورها مرَّة في الأسبوع، تضع النرجس والجوري.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا تقصد؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندَما يزورها ابنُها الصَّغير تضعُ على الشُّرفةِ إضافةً للنرجس ورداً جوريّاً، ليحلَّ محلَّ غيابها عنّي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا لم تُفكِّر بالزَّواج منها بعدَ وفاة زوجها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا؟ ماذا سأُقدِّم لها؟ أنا أحبّها وهي تعرف، أُقدِّم لها كلَّ ما أملك من وفاءٍ وعرفان على جميلها معي، أنا لا أملك شيئاً يمكنُني تقديمُه ولم أقدِّمه، أحببتها حبَّ روحٍ وليس حُبَّ جسدٍ، هي بوجودها سبب استمراري، أنا أعرف أنّي سأموتُ في اليوم الَّذي ستموت فيه.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ راضي بسخرية واضحة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآن أنتَ كافر!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لأنَّ الأعمارَ بيد الله، هو الوحيد الَّذي يُحدِّد نهاية الأيَّام.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّ الله الَّذي أعرفه هو مَن أمدَّها وأمدَّني بالمحبّة، ولأنَّني وهي نحبّه كثيراً، (نظر أبو سمرة للسَّماء وتابع)، إنَّه يعرفُ تماماً أنَّه لا يمكن لأحدِنا أن يحيا بعد الآخر، سنموتُ معاً؛ ستشهد على ذلك، كلّ ما أطلبُه من الله هو ساعاتٌ قليلة بعدها، لأزرعَ لها نرجسها الَّذي تحبّ بجانب قبرها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ألا تريد أن تُدفنَ بجانبها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يبعد روحينا أيّ جدار في الحياة، ولن يكون لكلّ الجدران أيّ معنىً بعد الموت، سنلتقي؛ لأنَّ ما بيننا هو الحبّ والحبّ فقط.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يُسجِّل راضي أيَّ شيء، لم يستطعْ أن يحدِّدَ إذا كانت القصَّة حقيقيَّة، أم أنها من تأليف أبي سمرة، نظرَ إليه وتأمَّله؛ لم يُلاحظ القباحةَ الَّتي تحدَّث عنها، نظر إلى الشُّرفة فوجدَ ورداً جوريّاً أبيض يلوح في الأعلى، عادَ إلى مقعده في الحديقة انتظرَ صديقته، وعندما حضرَت لاحظَ الطّيور فوق الشجرة، في نهاية النَّهار، كان أبو سمرة يحرس سيّدة عجوز، تمشي بهدوء متَّكئة على عصا، يحملُ لها شالها، هي تبتسم بمحبّة، وهو يقدِّر محبّتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ شهر تقريباً، في يومِ مطرٍ غزير، حضر راضي إلى الحديقة، كانَ الكشك مقفلاً، نظرَ إلى الشُّرفة فلم يجدْ أزهار النَّرجسِ، انتظرَ كثيراً، بلَّلهُ المطرُ وأخفى دموعه، إلَّا أنَّ أبا سمرة لم يحضر، تُرى هل توفيت أحلام؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألَ بعضَ الجيران، وتأكَّد من الخبر، سألَ عن مكان قبرها وذهبَ لزيارتها مسرعاً؛ ليقفَ مع ذاك العجوز الوحيد في حزنه، كانَ النَّهار يودِّعُ الضِّياء، والمطر يبحثُ عن مخابئ بين جذوع الأشجار، وصلَ راضي ووجدَ قبراً مليئاً بأزهار النَّرجس يرقدُ بجانبه رجل ضئيل البنية أشعث الشَّعر قبيحَ الوجه، يحملُ في يديه وردةً حمراء نديَّة وبقايا روح تنشرُ المحبّة.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("20-5-2021")]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0